import { apiInterfaceForFormData, apiInterfaceForJson } from "../common/apiManager";

export const importSolanaResultDocument = (data) => {
    return apiInterfaceForJson("/solanaResultImport/v1/importResultDocument", "POST", data);
}

export const uploadSolanaResultDocument = (formData) => {
    return apiInterfaceForFormData("/solanaResultImport/v1/uploadResultDocument/", "POST", formData);
};